module.exports = __webpack_public_path__ + "img/return-people.f8724622.svg";